import http from './http';

export async function listResidenceBuildings(residenceId) {
  const { data } = await http.get(`/residences/${residenceId}/buildings`);
  return data;
}

export async function adminListResidenceBuildings(residenceId) {
  const { data } = await http.get(`/admin/residences/${residenceId}/buildings`);
  return data;
}

export async function adminCreateResidenceBuilding(residenceId, payload) {
  const { data } = await http.post(`/admin/residences/${residenceId}/buildings`, payload);
  return data;
}

export async function adminUpdateBuilding(id, payload) {
  const { data } = await http.put(`/admin/buildings/${id}`, payload);
  return data;
}

export async function adminDeleteBuilding(id) {
  const { data } = await http.delete(`/admin/buildings/${id}`);
  return data;
}
